import { useEffect, useRef } from "react";

/**
 * IntersectionObserver-backed hook that toggles `data-paused="true"` on the
 * returned ref when the element leaves the viewport. Pair with a global CSS
 * rule that maps that attribute to `animation-play-state: paused`.
 */
export function usePauseWhenOffscreen<T extends Element>(margin = "200px") {
  const ref = useRef<T | null>(null);

  useEffect(() => {
    const el = ref.current;
    if (!el || typeof IntersectionObserver === "undefined") return;

    const io = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) el.removeAttribute("data-paused");
        else el.setAttribute("data-paused", "true");
      },
      { rootMargin: margin },
    );
    io.observe(el);
    return () => io.disconnect();
  }, [margin]);

  return ref;
}
